import { useEffect, useRef, useState } from "react";
import { useImmer } from "use-immer";
import SimpleReactValidator from "simple-react-validator";
import { errorMessage, successMessage } from "../../../utils";
import {
  getTenantBusinessDetailsApi,
  updateTenantBusinessDetailsApi,
} from "../apis/businessDetailsApis";

export const useBusinessDetailsConfig = () => {
  const [, setForceUpdate] = useState(0);
  const [state, setState] = useImmer({
    formData: {
      business_name: "",
      address: "",
      tax_id: "",
      brand_name: "",
      business_type: "",
    },
    isLoading: true,
    isSubmitting: false,
    hasChanges: false,
  });
  const formValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    }),
  );

  useEffect(() => {
    fetchBusinessDetails();
  }, [setState]);

  const fetchBusinessDetails = async () => {
    try {
      const response = await getTenantBusinessDetailsApi();

      if (response.data) {
        setState((draft) => {
          draft.formData = response.data;
          draft.hasChanges = false;
        });
      } else {
        errorMessage(response?.message || "Failed to load business details");
      }
    } catch (error) {
      errorMessage(
        error.response?.data?.message ||
          error.message ||
          "Failed to load business details",
      );
    } finally {
      setState((draft) => {
        draft.isLoading = false;
      });
    }
  };

  const onChange = (event) => {
    const { name, value } = event.target;
    setState((draft) => {
      draft.formData[name] = value;
      draft.hasChanges = true;
    });
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    if (!formValidator.current.allValid()) {
      formValidator.current.showMessages();
      setForceUpdate((previous) => previous + 1);
      return;
    }

    try {
      setState((draft) => {
        draft.isSubmitting = true;
      });

      const response = await updateTenantBusinessDetailsApi(state.formData);

      if (response?.success) {
        setState((draft) => {
          draft.formData = response.data;
          draft.hasChanges = false;
        });
        successMessage(
          response.message || "Business details saved successfully",
        );
      } else {
        errorMessage(response?.message || "Failed to save business details");
      }
    } catch (error) {
      errorMessage(
        error.response?.data?.message ||
          error.message ||
          "Failed to save business details",
      );
    } finally {
      setState((draft) => {
        draft.isSubmitting = false;
      });
    }
  };

  return { state, formValidator, onChange, onSubmit };
};
